import React from 'react';
import '../App.css';

const UpcomingEvents = () => {
  return (
    <div className="container">
      <h2 className="page-title">Upcoming Events</h2>
      <p>This page will display all the upcoming events for the institute.</p>
    </div>
  );
};

export default UpcomingEvents;
